import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { Trans } from 'react-i18next';
import { FlexColumn, BodySemiBold, FlexSpace, Button as BaseButton, FlexMiddle } from '@ubeya/shared-web/components';
import { ReactComponent as CreditCardsIcons } from '@ubeya/shared-web/assets/credit-card-icons.svg';
import ViewCreditCard from './ViewCreditCard';
import AddCreditCard from './AddCreditCard';

const Wrapper = styled(FlexColumn)`
  grid-row: span 3;
  ${({ $isAddingCard }) =>
    !$isAddingCard &&
    css`
      align-self: stretch;
    `}
`;

const TitleContainer = styled(FlexMiddle)`
  width: 100%;
  justify-content: space-between;

  svg {
    width: 200px;
  }
`;

const Container = styled(FlexMiddle)`
  border-radius: 5px;
  justify-content: space-between;
`;

const Button = styled(BaseButton)`
  border-color: transparent;

  &:not(:disabled):hover {
    border-color: transparent;
  }
`;

const CreditCard = ({ method, addBillingMethod, setIsChangingMethod }) => {
  const [isCardOpen, setIsCardOpen] = useState(false);

  const isAddingCard = isCardOpen || !method;

  const handleClickChangeMethod = () => {
    setIsCardOpen(true);
    setIsChangingMethod?.(true);
  };

  return (
    <Wrapper $isAddingCard={isAddingCard}>
      <FlexSpace>
        <TitleContainer>
          <BodySemiBold>
            <Trans>creditDetails</Trans>
          </BodySemiBold>
          {isAddingCard && <CreditCardsIcons />}
        </TitleContainer>

        {!isAddingCard && (
          <Button link onClick={handleClickChangeMethod}>
            <Trans>change</Trans>
          </Button>
        )}
      </FlexSpace>

      <Container>
        {isAddingCard ? (
          <AddCreditCard onClose={() => setIsCardOpen(false)} onConfirm={addBillingMethod} />
        ) : (
          <ViewCreditCard creditCard={method} />
        )}
      </Container>
    </Wrapper>
  );
};

export default CreditCard;
